import { createTheme, responsiveFontSizes } from '@mui/material/styles';

let theme = createTheme({
  palette: {
    primary: {
      main: '#231161',
    },
    secondary: { main: '#FFFFFF' },
    error: {
      main: '#E9573D',
      light: '#E9573D1A',
    },
    text: {
      primary: '#181818',
    },
    background: {
      paper: 'white',
      default: '#FFFFFF',
    },
    action: {
      active: '#C3002F',
      hover: '#C3002FBF',
      selected: '#C3002FBF',
      disabled: '#C3002F40',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1000,
      lg: 1200,
      xl: 1800,
    },
  },
  spacing: 2,
  zIndex: {
    appBar: 1100,
    modal: 1300,
  },
  typography: {
    fontFamily: 'Barlow',
    button: {
      textTransform: 'none',
      fontFamily: 'Barlow',
    },
  },
});

theme = responsiveFontSizes(theme);

export default theme;
